/** DOM id for portaling the mobile messages trigger into the app header (where ChatBubble lived). */
export const FLOATING_MESSAGES_MOBILE_HEADER_SLOT_ID = 'floating-messages-mobile-header-slot';

/**
 * Public campaign detail pages where the messages trigger belongs in the header
 * (avoids overlapping bottom CTAs like Apply Now).
 *
 * Matches: `/campaign/:id`, `/campaigns/:id`, `/buzzbridge/:id`
 * Excludes sub-routes (manage, entries, workspace, etc.).
 */
export function isCampaignContestDetailPath(pathname: string): boolean {
    const normalized = pathname.replace(/\/$/, '') || '/';
    const segments = normalized.split('/').filter(Boolean);
    if (segments.length !== 2) return false;
    const [root, id] = segments;
    if (!id) return false;
    return root === 'campaign' || root === 'campaigns' || root === 'buzzbridge';
}

/** “Small mobile” breakpoint for floating-messages UX (narrow phones only; tablets use desktop-style modals). */
export const SMALL_MOBILE_MEDIA_QUERY = '(max-width:415px)';

/**
 * Short viewports such as 1024×600: cap floating / avatar panel height so the sheet stays fully visible
 * (excludes ≤415px small-mobile, which uses different entry points).
 */
export const FLOATING_PANELS_SHORT_VIEWPORT_QUERY =
    '(max-width: 1024px) and (max-height: 600px) and (min-width: 416px)';
